import { Controller } from '@hotwired/stimulus'
import axios from 'axios'
import '@dmuy/toast/dist/mdtoast.css'
import mdtoast from '@dmuy/toast'

export default class extends Controller {
  static targets = [
    'checkbox',
    'label',

  ]

  static values = {
    enabled: { type: Boolean, default: false },
    pageType: { type: String, default: '' },
    organizationId: { type: String, default: '' }
  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('plan change controller connected.')

    if (this.enabledValue) {
      this.checkboxTarget.checked = true
      this.labelTarget.innerText = "Setup Complete"
    }
  }

  disconnect() {
  }

  toggle(evt) {
    evt.preventDefault()

    axios.get(`/organizations/${this.organizationIdValue}/toggle_internal_team_setup`)
      .then((response) => {
        if (response.data.current) {
          this.labelTarget.innerText = "Setup Complete"
          mdtoast.success('Setup complete.', { duration: 10000 })
        } else {
          this.labelTarget.innerText = "Setup Incomplete"
          mdtoast.error('Setup incomplete.', { duration: 10000 })
        }
      }).catch((error) => {
        console.log(error)
      })
  }
}
